// extracted by mini-css-extract-plugin
export default {"rainContainer":"rain_rainContainer__6772x","raindrop":"rain_raindrop__zZRGj"};